import { NgModule } from '@angular/core';

import { MijnLoginTemplateModule } from '@ap/mijn-template';
import { ApContentModule } from '@ap/content';

import { ErrorModule } from '../../klant/login/error/error.module';

import { ErrorWrapperComponent } from './error.wrapper.component';

/**
 * @ngdoc module
 * @name ErrorWrapperModule
 */
@NgModule({
    declarations: [ErrorWrapperComponent],
    imports: [ApContentModule, ErrorModule, MijnLoginTemplateModule],
    exports: [ErrorWrapperComponent]
})
export class ErrorWrapperModule {}
